// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getMessaging, isSupported, onRegistered, register } from 'firebase/messaging';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

//
// const firebaseConfig = {
//   apiKey: "AIzaSyBUdVQKSYiMrWXKZLhpcR4pmtIUFa-40w0",
//   authDomain: "zapkartnew2022-dc8a8.firebaseapp.com",
//   projectId: "zapkartnew2022-dc8a8",
//   storageBucket: "zapkartnew2022-dc8a8.appspot.com",
//   messagingSenderId: "812753080859",
//   appId: "1:812753080859:web:63d1a2c52ff2a2a5161ebe",
// };

// // Initialize Firebase
// const intializeFirebase = initializeApp(firebaseConfig);

// export const authentication = getAuth(intializeFirebase);

// Your web app's Firebase configuration
let firebaseConfig = {};

// if ("Live" === 'Live') {
//   firebaseConfig = {
//     apiKey: 'AIzaSyDVRszGmdIg-Me-79_x9yuntOdt6Mz2LdM',
//     authDomain: 'zapkartlive.firebaseapp.com',
//     projectId: 'zapkartlive',
//     storageBucket: 'zapkartlive.appspot.com',
//     messagingSenderId: '1010821971171',
//     appId: '1:1010821971171:web:dcd6a429a1f65cb3ead9d6',
//   }
// } else {
//   firebaseConfig = {
//     apiKey: 'AIzaSyDVRszGmdIg-Me-79_x9yuntOdt6Mz2LdM',
//     authDomain: 'zapkartlive.firebaseapp.com',
//     projectId: 'zapkartlive',
//     storageBucket: 'zapkartlive.appspot.com',
//     messagingSenderId: '1010821971171',
//     appId: '1:1010821971171:web:dcd6a429a1f65cb3ead9d6',
//   }
// }

if ("Live" === 'Live') {
  firebaseConfig = {
    apiKey: 'AIzaSyDVRszGmdIg-Me-79_x9yuntOdt6Mz2LdM',
    authDomain: 'zapkartlive.firebaseapp.com',
    projectId: 'zapkartlive',
    storageBucket: 'zapkartlive.appspot.com',
    messagingSenderId: '1010821971171',
    appId: '1:1010821971171:web:dcd6a429a1f65cb3ead9d6',
    measurementId: "G-FBWMFCCWG7"
  };
} else {
  firebaseConfig = {
    apiKey: 'AIzaSyDmZpETpKWwUkYbDJdmq9XKmpK3iTcs6Dc',
    authDomain: 'ecommerce-test-e6c33.firebaseapp.com',
    projectId: 'ecommerce-test-e6c33',
    storageBucket: 'ecommerce-test-e6c33.appspot.com',
    messagingSenderId: '2805389390',
    appId: '1:2805389390:web:31c1bd337020b2368f0b1f'
  };
  // firebaseConfig = {
  //   apiKey: 'AIzaSyDE96sBpGy5JJKHNwTHP3OuUSChRCIgH_U',
  //   authDomain: 'ecommerce-74b71.firebaseapp.com',
  //   projectId: 'ecommerce-74b71',
  //   storageBucket: 'ecommerce-74b71.appspot.com',
  //   messagingSenderId: '1031062435017',
  //   appId: '1:1031062435017:web:d6b5ac03cd40d344480918'
  // };
}

//console.log('firebaseConfig', firebaseConfig);

// Initialize Firebase
const intializeFirebase = initializeApp(firebaseConfig);

export const authentication = getAuth(intializeFirebase);
export const auth = getAuth(intializeFirebase);

if ("Live" !== 'Live') {
  authentication.settings.appVerificationDisabledForTesting = true;
}

let messaging = null;

const vapidKey =
  "Live" === 'Live'
    ? "BNuEPsg2Kt4EMd7OQJ2w1N_5LaeXREfaGKo6eWubYMxV1CkUbDs7VS0UtH_3YbVKin0HLTJTRtVZpeNcijumS0Q"
    : "BFG_w4_cHmKROSFfUrSbP1kfS_QPu_vn0fQkI_i5AZv0qXtM9YngWca_0hO1O_mbRKVcLM8xDST5sZ7bfrPCDuM";

export const getDeviceToken = async (setDeviceToken) => {
  try {
    const supported = await isSupported();
    if (!supported) {
      setDeviceToken(null);
      return;
    }

    if (!messaging) {
      messaging = getMessaging(intializeFirebase);
    }

    onRegistered(messaging, (installationId) => {
      setDeviceToken(installationId || null);
    });
    await register(messaging, { vapidKey });
  } catch (err) {
    setDeviceToken(null);
  }
};

export default intializeFirebase;

